



































import { Component, Prop, Vue } from 'vue-property-decorator';
import PxDropdown from '@/views/components/input/formFields/PxDropdown.vue';
import PxNumberInput from '@/views/components/input/formFields/PxNumberInput.vue';
import ProbabilisticChart from '@/modules/lcca/views/components/ProbablisticChart.vue';
import { ILccaActivityImperial, ILccaActivityMetric } from '@/modules/lcca/interfaces/lccaCalculated';
import PxTextArea from '@/views/components/input/formFields/PxTextArea.vue';
import PxTextEntryBox from '@/views/components/input/formFields/PxTextEntryBox.vue';
import QuickHelp from '@/views/components/input/QuickHelp.vue';
import { UnitSystem } from '@/interfaces/units';
import { ImperialUnits, MetricUnits } from '@/lib/unitConversion/unitConversionFactors';
import { lccaStore } from '@/store/store';

@Component({
  components: {
    QuickHelp,
    PxTextEntryBox,
    PxTextArea,
    ProbabilisticChart,
    PxDropdown,
    PxNumberInput,
  },
})
export default class AgencyCostEditor extends Vue {
  @Prop() activity!: ILccaActivityImperial | ILccaActivityMetric;

  // @PropSync('alternative') alt!: ILccaAlternative;

  sync() {
    this.$emit('sync');
  }

  unitSystemIsImperial() {
    return lccaStore.displayUnits === UnitSystem.Imperial;
  }

  get unitOptions() {
    if (this.unitSystemIsImperial()) {
      return Object.values(ImperialUnits).map((U) => ({ value: U, text: U }));
    } 
      return Object.values(MetricUnits).map((U) => ({ value: U, text: U }));
  }

  newLineItem() {
    this.activity.lineItems.push({
      // @ts-ignore
      id: null,
      // @ts-ignore
      units: null,
      // @ts-ignore
      quantity: 0,
      // @ts-ignore
      unitDescr: null,
      // @ts-ignore
      unitCost: 0,
      // @ts-ignore
      name: null,
      // @ts-ignore
      unitSystem: this.activity.unitSystem,
    });
  }

  fields = [
    { key: 'name', label: 'Name' },
    { key: 'units', label: 'Units' },
    { key: 'quantity', label: 'Quantity' },
    { key: 'unitCost', label: 'Unit Cost' },
    { key: 'subtotal', label: 'Sub-Total' },
  ]
}
